import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ContactFormComponent } from './contact-form.component';
import { HttpModule } from '@angular/http';
import { CONTService } from './cont.service';

@NgModule({
    imports: [BrowserModule, FormsModule, HttpModule],
    declarations: [AppComponent, ContactFormComponent],
    bootstrap: [AppComponent],
    providers: [CONTService]
})
export class AppModule { }
